export default "__VITE_ASSET__a3c9e3f4__"